$(document).ready(function() {

  // img fullsize
	$("img").fullsize();
	
	// popup for txt
	$(".item span.txt").css({"cursor":"pointer",'color':'#4CB002'}).click(function(e){
    var width = $('body').width();
    var posLeft = e.pageX + 25;
    var posTop = e.pageY - 10;
    if (posLeft + 300 > width) posLeft -=400;
    if (posLeft<0) posLeft = 10;
		$("div#popup").remove();
		var txt=$(this).html();
		$("body").prepend('<div id="popup" class="fullsize-wrapper"><div class="fullsize-sh-top"><div class="fullsize-sh-top-l"/><div class="fullsize-sh-top-r"/><div class="fullsize-sh-top-m"/></div>'+
													'<div class="fullsize-sh-body"><div class="fullsize-sh-body-r"><div class="scroll">'+txt+'</div></div></div>'+
													'<div class="fullsize-sh-bottom"><div class="fullsize-sh-bottom-l"/><div class="fullsize-sh-bottom-r"/><div class="fullsize-sh-bottom-m"/></div></div>');
		$("div#popup").css({left:posLeft,top:posTop}).show().click(function(){
			$(this).fadeOut(100,function(){
				$(this).remove();
			});
		});
	});



	// submit form when changed sort fields
	$(".searchForm select.order, .searchForm select.limit").change(function(){
		$(".searchForm form").trigger('submit');
	});

	// submit form and change form action when pager is active and clicked
	$(".pager a").click(function(event){
		event.preventDefault();
		action=event.target.href;
		$(".searchForm form").attr("action",action);
		$(".searchForm form").trigger('submit');
	});

	bind_field_changes();

	// add new search fields
	searchFields=$("p.search").length-1;
	newSearch='<p class="search">'+$("p.search").html()+"</p>";
	newSearch=newSearch.replace(/Zoek:/,"&nbsp;");
	var addSearchHtml='<a class="addSearch" href="" title="voeg zoek criterium toe"> + </a> | <a class="minSearch" href="" title="verwijder zoek criterium"> - </a>';
	if ($("p.search .search:first").length>0)
		$("p.search .search_term:first").after(addSearchHtml);
	// else
	// 	$("p.search input.search:first").after(addSearchHtml);
	$("p.search .addSearch").click(function(event){
		event.preventDefault();
		searchFields++;
		thisSearch=newSearch.replace(/and_0/g,'and_'+searchFields);
		thisSearch=thisSearch.replace(/field_0/g,'field_'+searchFields);
		thisSearch=thisSearch.replace(/equal_0/g,'equal_'+searchFields);
		thisSearch=thisSearch.replace(/term_0/g,'term_'+searchFields);
		$("p.search:last").after(thisSearch);
		$("p.search:last input.search").attr("value","");
		bind_field_changes();
	});
	$("p.search .minSearch").click(function(event){
		event.preventDefault();
		if (searchFields>=1) {
			searchFields--;
			$("p.search:last").remove();
			bind_field_changes();
		}
	});
	
});
  
  

function bind_field_changes() {
	// change field types
	$("p.search select.searchin").unbind().change(function(event){
		selected=$(this).attr("value");
		pre=selected.substr(0,selected.indexOf("_"));
    var input = $(this).next('select').next(".search_field");
    if (input.length>0) {
			var name=$(input).attr("name");
  		if (pre==="b") {
				$(input).after('<select class="boolean" name="'+name+'" value="0"><option selected value="0">Nee</option><option value="1">Ja</option></select>').remove();
  		}
  		else {
				$(input).after('<input class="term" name="'+name+'" value=""></input>').remove();
  		}
    }
	});
}